import type { GapType } from './types';

/** Fixed display order across every view. New-form-required first. */
export const GAP_TYPE_ORDER: GapType[] = [
  'new_form_required',
  'change_form_fields',
  'change_workflow_approvals',
  'other_changes',
];

export const FORM_GAP_TYPES: GapType[] = [
  'change_form_fields',
  'change_workflow_approvals',
  'other_changes',
];
export const STREAM_GAP_TYPES: GapType[] = ['new_form_required'];

export const GAP_TYPE_META: Record<
  GapType,
  { label: string; shortLabel: string; badgeClass: string; dotClass: string }
> = {
  new_form_required: {
    label: 'New form required',
    shortLabel: 'New form',
    badgeClass: 'bg-violet-50 text-violet-800 border border-violet-200',
    dotClass: 'bg-violet-500',
  },
  change_form_fields: {
    label: 'Change form fields',
    shortLabel: 'Fields',
    badgeClass: 'bg-amber-50 text-amber-800 border border-amber-200',
    dotClass: 'bg-amber-500',
  },
  change_workflow_approvals: {
    label: 'Change workflow/approvals',
    shortLabel: 'Workflow',
    badgeClass: 'bg-sky-50 text-sky-800 border border-sky-200',
    dotClass: 'bg-sky-500',
  },
  other_changes: {
    label: 'Other changes',
    shortLabel: 'Other',
    badgeClass: 'bg-slate-100 text-slate-700 border border-slate-200',
    dotClass: 'bg-slate-500',
  },
};
